import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import ListGroup from "react-bootstrap/ListGroup";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Container from "react-bootstrap/Container";
import RequestersDetails from "../details/RequestersDetails";
import Prompt from "../../ui/prompts/Prompt";
import {
  Title,
  SpinnerContainer,
  ContentHeader,
  ViewsContainer,
  ViewsTitleContainer,
} from "../../ui/BaseComponents";
import { Spinner, Stack } from "react-bootstrap";

export default function ViewRequesters({ data, isLoading }) {
  const [savedId, setSavedId] = useState();

  return (
    <Container fluid>
      <Title>{"Requester Details"}</Title>
      {isLoading ? (
        <SpinnerContainer>
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
        </SpinnerContainer>
      ) : (
        <Stack>
          <ContentHeader>{"Service Requesters"}</ContentHeader>
          <Row className='justify-content-md-center'>
            <Tab.Container
              id='list-group-tabs-example'
              defaultActiveKey={savedId}
            >
              <Col xs lg='5'>
                <ViewsContainer style={{ marginLeft: "5%" }}>
                  <ViewsTitleContainer>
                    {"Service Requesters"}
                  </ViewsTitleContainer>
                  <ListGroup>
                    {data.map((item: any, i) => (
                      <ListGroup.Item
                        style={
                          i % 2 === 0
                            ? {
                                height: "4em",
                                color: "#292929",
                                border: "none",
                                backgroundColor: "#D8ECFD",
                              }
                            : {
                                height: "4em",
                                color: "#292929",
                                border: "none",
                                backgroundColor: "#ECF3FE",
                              }
                        }
                        key={i}
                        action
                        variant='dark'
                        eventKey={i}
                        onClick={() => setSavedId(i)}
                      >
                        {item.first_name} {item.last_name}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </ViewsContainer>
              </Col>

              <Col xs lg='7'>
                <ViewsContainer style={{ marginRight: "5%" }}>
                  <ViewsTitleContainer>{"Details"}</ViewsTitleContainer>
                  <Tab.Content style={{ padding: ".4em" }}>
                    {savedId === undefined ? (
                      <Prompt message='Select a requester to view details.' />
                    ) : (
                      <Tab.Pane eventKey={savedId}>
                        {typeof savedId === "number" ? (
                          <RequestersDetails
                            data={data[savedId]}
                            id={data[savedId].requester_id}
                          />
                        ) : null}
                      </Tab.Pane>
                    )}
                  </Tab.Content>
                </ViewsContainer>
              </Col>
            </Tab.Container>
          </Row>
        </Stack>
      )}
    </Container>
  );
}
